export default "__VITE_ASSET__CMEN2X6F__"